"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slovakiaTranslations = void 0;
var _types = require("../../../types");
const slovakiaTranslations = exports.slovakiaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Je nám to ľúto!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Späť',
  [_types.ErrorPageTranslationKey.text]: 'Stránka momentálne nie je v prevádzke.',
  [_types.ErrorPageTranslationKey.notFound]: 'Stránka, ktorú hľadáte, pravdepodobne nefunguje',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Stránka, ktorú hľadáte je neprístupná, neboli splnené podmienky pre prístup.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Prosím, kontaktujte tím podpory Oriflame e-mailom:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Požadovaná URL adresa bola zamietnutá!'
};
